import React from 'react'
import EqxLoading from '../../shared/components/EqxLoading'
import generateContextProvider, { ContextProviderWrapperProps } from '../../shared/hooks/GenerateContextProvider'
import { useApiContext } from './AppApi'
import { useAuthContext } from './AppAuth'
import { savePostAuthReturnFromWindow } from './authReturnPath'
import { useAuthOAuthContext } from './AppAuthOAuth'

/**
 * ensure the token is loaded before rendering the children
 * @param props
 * @returns
 */
const AppAuthTokenWrapper = (props: ContextProviderWrapperProps<string>) => {
    const TokenProvider = props.provider
    const auth = useAuthContext()
    const oauth = useAuthOAuthContext()
    const api = useApiContext()
    const token = auth.token

    api.token = token

    React.useEffect(() => {
        if (token) return
        // Sign-out clears JWT + AAD; do not treat that like "save deep link and send to /".
        if (auth.isLoggingOut) return
        // MSAL present but JWT absent: AppAuth re-exchanges above us; avoid hard redirect.
        if (oauth.aadAccessToken) return
        savePostAuthReturnFromWindow()
        window.location.assign('/')
    }, [token, oauth.aadAccessToken, auth.isLoggingOut])

    if (!token) {
        return <EqxLoading message="Redirecting to sign in..." />
    }

    return <TokenProvider value={token}>{props.children}</TokenProvider>
}

const {
    ContextProvider: AppAuthTokenProvider,
    useContext: useTokenContext,
    useContextOptional: useTokenContextOptional,
} = generateContextProvider<string>(undefined, AppAuthTokenWrapper)

export { AppAuthTokenProvider as default, useTokenContext, useTokenContextOptional }
